// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import IconButton from 'presentations/views/components/atoms/IconButton';
import { gray06, gray03 } from 'presentations/views/styles/color';
import {
  spacing,
  fontSize,
  borderRadius,
  mediaMaxWithLayoutTheme,
} from 'presentations/views/styles';
import { WorkflowType } from 'domains/models/workflow/workflowType';
import Workflow from 'domains/models/workflow';
import { SyntheticEvent } from 'react';
import Select from 'presentations/views/components/atoms/Select';
import TextField from 'presentations/views/components/atoms/TextField';

interface Props {
  workflow: Workflow;
  onDelete: (workflow: Workflow) => void;
  onChange: (e: SyntheticEvent<HTMLInputElement>, workflow: Workflow) => void;
  isDraggable: boolean;
  isEditable: boolean;
  label: string | null;
}

export default function Component(props: Props) {
  let isEditable = false;
  switch (props.workflow.workflowType) {
    case WorkflowType.QuestionAnswerText:
      isEditable = true;
      break;
    default:
  }

  function onDelete(e: SyntheticEvent<HTMLButtonElement>) {
    props.onDelete(props.workflow);
  }

  function onChange(e: SyntheticEvent<HTMLInputElement>) {
    props.onChange(e, props.workflow);
  }

  const t = translateInComponent(translations);
  const options = [
    { value: WorkflowType.QuestionAnswerText, text: t(`QuestionAnswerText`) },
    { value: WorkflowType.QuestionAnswerEmoji, text: t(`QuestionAnswerEmoji`) },
    { value: WorkflowType.Task, text: t(`Task`) },
    { value: WorkflowType.Kudos, text: t(`Kudos`) },
    { value: WorkflowType.Suggestion, text: t(`Idea`) },
  ];
  let placeholder: string = '';
  switch (props.workflow.workflowType) {
    case WorkflowType.QuestionAnswerText:
      placeholder = t('Placeholder QuestionAnswerText');
      break;
    case WorkflowType.QuestionAnswerEmoji:
      placeholder = t('Placeholder QuestionAnswerEmoji');
      break;
    case WorkflowType.Kudos:
      placeholder = t('Placeholder Kudos');
      break;
    case WorkflowType.Suggestion:
      placeholder = t('Placeholder Suggestion');
      break;
    default:
      break;
  }

  return (
    <Container>
      {props.isDraggable && <DragHandle name="drag_indicator" />}
      <Left>
        <ListItem>
          <Type>
            <StyledSelect
              name="workflowType"
              value={props.workflow.workflowType}
              options={options}
              onChange={onChange}
            />
          </Type>
          {props.workflow.workflowType !== WorkflowType.Task && (
            <Content>
              <TextField
                name={'content'}
                onChange={onChange}
                value={props.workflow.content}
                isFullWidth={true}
                placeholder={placeholder}
              />
            </Content>
          )}
        </ListItem>
        {props.isEditable && (
          <>
            <IconButton onClick={onDelete}>
              <DeleteIcon name="delete" />
              <DeleteLabel>{t('Delete')}</DeleteLabel>
            </IconButton>
          </>
        )}
      </Left>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${gray06};
  padding: ${spacing(16)};
  border-radius: ${borderRadius()};
  width: 100%;

  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    padding: ${spacing(12)};
  }
`;
const DragHandle = styled(Icon)`
  margin-right: ${spacing(8)};
  /* font-size: ${fontSize(14)}; */
  color: ${gray03};
`;
const Left = styled.div`
  width: calc(100% - 56px);
  display: flex;
  align-items: center;

  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    width: 100%;
    flex-direction: column;
    align-items: flex-end;
  }
`;
const Content = styled.div`
  flex: 1;
  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    margin-top: ${spacing(8)};
  }
`;
const ListItem = styled.div`
  margin-left: ${spacing(8)};
  display: flex;
  align-items: center;
  width: 100%;
  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    display: block;
  }
`;
const Type = styled.div`
  margin-right: ${spacing(16)};
  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    width: 100%;
    margin-right: 0;
  }
`;
const StyledSelect = styled(Select)`
  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    width: 100%;
    font-size: 12px;
  }
`;
const DeleteIcon = styled(Icon)``;
const DeleteLabel = styled.span`
  display: none;
  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    display: initial;
    font-size: ${fontSize(10)};
  }
`;
